import React from "react";
import { Icon, type IconName } from "../Icon";

interface IconButtonProps extends Omit<React.ButtonHTMLAttributes<HTMLButtonElement>, "type"> {
  iconName: IconName;
  size?: number;
  ariaLabel: string;
  badge?: boolean;
  type?: "button" | "submit" | "reset";
}

export const IconButton: React.FC<IconButtonProps> = ({
  iconName,
  size = 16,
  ariaLabel,
  badge = false,
  type = "button",
  className = "",
  ...rest
}) => (
  <button
    type={type}
    aria-label={ariaLabel}
    title={ariaLabel}
    className={"ds-icon-btn " + className}
    {...rest}
  >
    <Icon name={iconName} size={size} />
    {badge && <span className="ds-badge-dot" />}
  </button>
);
